export const LANDING = '/';
export const MOBILE = '/mobile';
export const DESKTOP = '/desktop';
